module.exports = __webpack_public_path__ + "5a87e3e8e169f362d7ec62f0f0de61c5.fbx";